<script setup lang="ts">
import { ref } from 'vue'
import EmailImage from '@/components/svg/Email.vue'

const emit = defineEmits(['goBack'])

const email = ref(sessionStorage.getItem('email'))
</script>

<template>
  <header data-testid="result-section">
    <div class="row">
      <div class="col text-left mt-4">
        <a href="#" @click.prevent="emit('goBack')" class="back-link fw-bold">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 10 15"
            fill="none"
          >
            <path
              d="M7.0607 9.0393C7.6464 9.6251 7.6464 10.5749 7.0607 11.1607C6.4749 11.7464 5.5251 11.7464 4.9393 11.1607L0.93934 7.1607C0.35355 6.5749 0.35355 5.6251 0.93934 5.0393L4.9393 1.03934C5.5251 0.45355 6.4749 0.45355 7.0607 1.03934C7.6464 1.62513 7.6464 2.57487 7.0607 3.16066L4.1213 6.1L7.0607 9.0393z"
              fill="currentColor"
            />
          </svg>
          back
        </a>
      </div>
    </div>

    <div class="row">
      <div class="col-6 m-auto text-center">
        <email-image class="my-5" />
        <h1 class="h3 mb-4" data-testid="result-title">
          {{ $t('result.title') }}
        </h1>
        <p class="lead mb-4" data-testid="result-lead">
          {{ $t('result.lead', { email }) }}
        </p>
        <p class="small" data-testid="result-help">
          {{ $t('result.help') }}
        </p>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
@media (min-width: 992px) {
  header {
    max-width: 75%;
    margin: auto;
  }
}

.back-link {
  transition: color 0.2s ease-in-out;
  color: #6c757d;

  svg {
    transition: transform 0.2s ease-in-out;
    transform: translateX(0) scale(1);
  }

  &:hover {
    color: #000;

    svg {
      transform: translateX(-2px) scale(0.8);
    }
  }
}
</style>
